// =============================================================================
// Shared trip/transport label maps.
//
// Single source of truth for the human-readable labels of the trip-type
// and transport-type enums, previously duplicated byte-for-byte across
// AdminBookingsPage, AdminReportsPage, and the TransportTypeStep form
// chip. Keys/values/casing are unchanged — this is a pure de-duplication.
// =============================================================================

export const TRIP_TYPE_LABEL: Record<string, string> = {
  one_way: "One Way",
  round_trip: "Round Trip",
  multi_leg: "Multi-Leg",
};

export const TRANSPORT_TYPE_LABEL: Record<string, string> = {
  AMB: "Ambulatory",
  "W/C": "Wheelchair",
  BWC: "Bariatric Wheelchair",
  STR: "Stretcher",
  BSTR: "Bariatric Stretcher",
};
